module.exports = __webpack_public_path__ + "static/logo-523adc89e8f7467e8204c623fddce4c6.svg";